import { z, type ZodType } from '../core/schema'

function normalizeBinaryValue(value: unknown): Uint8Array<ArrayBuffer> {
  if (ArrayBuffer.isView(value)) {
    return new Uint8Array(
      value.buffer,
      value.byteOffset,
      value.byteLength,
    ) as Uint8Array<ArrayBuffer>
  }

  if (value instanceof ArrayBuffer) {
    return new Uint8Array(value)
  }

  return value as Uint8Array<ArrayBuffer>
}

export const binarySchema = z.preprocess(
  normalizeBinaryValue,
  z.instanceof(Uint8Array),
) as ZodType<Uint8Array>

export function encodeBinary(value: Uint8Array): Uint8Array {
  const normalized = normalizeBinaryValue(value)
  return normalized instanceof Uint8Array ? normalized : value
}
